import * as React from 'react';
import clsx from 'clsx';
import pick from 'lodash/pick';
var styles = {
  "all": "SrOnly-all_3sYcg",
  "xsm": "SrOnly-xsm_1RcJL",
  "sm": "SrOnly-sm__Q7ui",
  "md": "SrOnly-md_2a_gt",
  "lg": "SrOnly-lg_3q4wX",
  "xlg": "SrOnly-xlg_Zt44Z",
  "xxlg": "SrOnly-xxlg_8W6qs",
  "wd": "SrOnly-wd_2uIj1",
  "xwd": "SrOnly-xwd_YII05",
  "from-xsm": "SrOnly-from-xsm_3bl_o",
  "from-sm": "SrOnly-from-sm_1eEk3",
  "from-md": "SrOnly-from-md_2VT0D",
  "from-lg": "SrOnly-from-lg_jCyy2",
  "from-xlg": "SrOnly-from-xlg_4J2Va",
  "from-xxlg": "SrOnly-from-xxlg_381sd",
  "from-wd": "SrOnly-from-wd_1CqJO",
  "from-xwd": "SrOnly-from-xwd_AZ8rl",
  "until-xsm": "SrOnly-until-xsm_3l88J",
  "until-sm": "SrOnly-until-sm_2PC-9",
  "until-md": "SrOnly-until-md_3sxG5",
  "until-lg": "SrOnly-until-lg_1vU7F",
  "until-xlg": "SrOnly-until-xlg_2Ze-2",
  "until-xxlg": "SrOnly-until-xxlg_w4-8H",
  "until-wd": "SrOnly-until-wd_M_33q",
  "until-xwd": "SrOnly-until-xwd_3YaZa"
};
function SrOnly(props) {
  const {
    xsm,
    sm,
    md,
    lg,
    xlg,
    xxlg,
    wd,
    xwd,
    at,
    from,
    until,
    component,
    tagName = 'span',
    className,
    children,
    ...extraProps
  } = props;
  const hasBreapoint = Object.values(pick(props, ['xsm', 'sm', 'md', 'lg', 'xlg', 'xxlg', 'wd', 'xwd', 'at', 'from', 'until'])).some(Boolean);
  const rootClasses = clsx({
    [styles.all]: !hasBreapoint,
    [styles.xsm]: xsm,
    [styles.sm]: sm,
    [styles.md]: md,
    [styles.lg]: lg,
    [styles.xlg]: xlg,
    [styles.xxlg]: xxlg,
    [styles.wd]: wd,
    [styles.xwd]: xwd
  }, at && styles[at], from && styles[`from-${from}`], until && styles[`until-${until}`], className);
  if (component && /*#__PURE__*/React.isValidElement(component)) {
    return /*#__PURE__*/React.cloneElement(component, {
      className: clsx(component.props.className, rootClasses),
      ...extraProps
    });
  }
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(tagName, {
      className: rootClasses,
      ...extraProps
    }, children);
  }
  return React.Children.toArray(children).map(child => /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
    className: clsx(child.props.className, rootClasses)
  }) : child);
}
export default SrOnly;